var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper--score flex-col ai-c",class:{ 'inactive' : _vm.showOptions }},[_c('p',[_vm._v("score")]),_c('p',{staticClass:"score-number",attrs:{"playerScore":_vm.playerScore}},[_vm._v(_vm._s(this.playerScore))])])}
var staticRenderFns = []

export { render, staticRenderFns }